<script>
import { defineComponent } from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import { BrandsPath, GravyPath, PackagingPath, RestaurantsPath } from "@/path";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Batches from "./batches.vue";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default defineComponent({
  props: ["selectedOrder", "order_type"],
  computed: {
    GravyPath() {
      return GravyPath;
    },
    RestaurantsPath() {
      return RestaurantsPath;
    },
  },
  components: { SelectWithSearch, DatePicker, Batches, StreamBarcodeReader },
  data() {
    return {
      form: {
        gravies: [],
        packagings: [],
        payment_mode: "credit",
        order_type: "online",
      },
      item_key: 0,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      currentGraviesPage: 1,
      currentPackagingPage: 1,
      gravies: [],
      packagings: [],
      cdn: process.env.VUE_APP_AWS_CDN,
      packaging_search: "",
      gravies_search: "",
      fields: ["batch_code", "name", "reason", "price", "actions"],
      pending_fields: ["batch_code", "name", "price", "actions"],
      fields_res: ["batch_code", "name", "reason", "price", "actions"],
      pending_fields_res: ["batch_code", "name", "price", "actions"],
      filter: "",
      orderGraviesfilter: "",
      orderPackagingsfilter: "",
      barcode: "",
      key: 0,
      restaurant: null,
      brands: [],
      selected_brand: null,
      expected_delivery_date: null,
      projection_date: null,
      itemsPerPage: 10,
      allSelected: [],
      selectedData: {},
      orderGraviesPage: 1,
      orderGraviestotalRows: 1,
      orderPackagingsPage: 1,
      orderPackagingstotalRows: 1,
      showBarcodeReader: false,
      reason_selected: null,
      reason_options: [
        {
          text: "not available at warehouse",
          value: "not available",
        },
        {
          text: "rp not accepting",
          value: "rp not accepting",
        },
        {
          text: "picking error",
          value: "picking error",
        },
        {
          text: "extra stock allocated to other cities",
          value: "extra stock allocated to other cities",
        },
        {
          text: "Frozen stocks not available",
          value: "frozen stocks not available",
        },
        {
          text: "Rp asking to send extra",
          value: "rp asking to send extra",
        },
        {
          text: "projection issue",
          value: "projection issue",
        },
      ],
      order_type_options: [
        {
          text: "Online",
          value: "online",
        },
        {
          text: "Dining",
          value: "dining",
        },
      ],
      payment_mode_options: [
        {
          text: "Credit",
          value: "credit",
        },
        {
          text: "Cash On Delivery",
          value: "cash_on_delivery",
        },
      ],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  watch: {
    currentGraviesPage() {
      this.getGravies();
    },
    currentPackagingPage() {
      this.getPackagings();
    },
    gravies_search() {
      this.currentGraviesPage = 1;
      this.getGravies();
    },
    packaging_search() {
      this.currentPackagingPage = 1;
      this.getPackagings();
    },
    selected_brand() {
      this.currentPage = 1;
      this.getGravies();
      this.getPackagings();
    },
    expected_delivery_date(v) {
      if (this.isToday(v) && this.isAfter5PM()) {
        const deliveryDate = this.calculateDayAfterTomorrow();
        console.log(
          "Delivery can be done the day after tomorrow:",
          deliveryDate.toDateString()
        );
      } else {
        console.log("Delivery cannot be done the day after tomorrow.");
      }
    },
    restaurant() {
      this.getBrands();
    },
    "form.res_id"() {
      this.getBrands();
      this.getGravies();
      this.getPackagings();
    },
    projection_date() {
      this.getGravies();
      this.getPackagings();
    },
  },
  mounted() {
    console.log(this.selectedOrder, "order");
    this.focusInput();
    if (
      this.$store.state.authfack.user.roles.filter(
        (f) => f.name == "RestaurantPartner"
      ).length > 0
    ) {
      this.form.res_id = this.$store.state.authfack.user.restaurant.id;
      this.form.order_type = "dining";
      this.form.payment_mode = "cash_on_delivery";
      this.restaurant = this.$store.state.authfack.user.restaurant;
    }
    if (Object.keys(this.selectedOrder).length > 0) {
      this.form.id = this.selectedOrder.id;
      this.form.order_type = this.selectedOrder.order_type;
      this.form.payment_mode = this.selectedOrder.payment_mode;
      this.form.res_id = this.selectedOrder.restaurant.id;
      this.form.expected_delivery_date =
        this.selectedOrder.expected_delivery_date;
      this.form.special_instruction = this.selectedOrder.special_instruction;
      this.restaurant = this.selectedOrder.restaurant;
      this.getOrderDetails();
    }
    if (this.form.res_id) {
      this.getBrands();
      this.getGravies();
      this.getPackagings();
    }
  },
  methods: {
    async processBarcode() {
      if (this.barcode.includes("PG")) {
        await this.getBarcodeGravies();
      } else if (this.barcode.includes("PP")) {
        await this.getBarcodePackagings();
      }
      this.barcode = "";
      this.focusInput();
    },
    async processBarcodeByCam(v) {
      this.barcode = v;
      if (this.barcode.includes("PG")) {
        await this.getBarcodeGravies();
      } else if (this.barcode.includes("PP")) {
        await this.getBarcodePackagings();
      }
      this.barcode = "";
    },
    focusInput() {
      this.$refs.barcodeInput?.focus();
    },
    calculateDayAfterTomorrow() {
      const today = new Date();
      const dayAfterTomorrow = new Date(today);
      dayAfterTomorrow.setDate(today.getDate() + 2);
      return dayAfterTomorrow;
    },
    isAfter5PM() {
      const now = new Date();
      return now.getHours() >= 12;
    },
    isToday(date) {
      const today = new Date();
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      );
    },
    async getBrands() {
      try {
        let res = await axios.get(this.baseUrl + BrandsPath.BASIC_BRAND, {
          params: {
            no_pagination: true,
            res_id: this.form.res_id,
          },
        });
        if (res.data.status) {
          this.brands = res.data.data;
          this.brands.unshift({
            id: "",
            name: "All",
          });
          this.selected_brand = res.data.data[0].id;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getOrderDetails() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.ORDERS.ORDER_ITEMS, {
          params: {
            order_id: this.selectedOrder.id,
            page: this.orderGraviesPage,
          },
        });
        if (res.data.status) {
          console.log(res.data.data, "asdfasf");
          this.form.gravies = res.data.data
            .filter((f) => f.gravy != null)
            .map((f) => {
              let g = f.gravy;
              g.batch_code = f.batch_code;
              g.qty_to_ship = f.qty_to_ship;
              g.reason = f.reason;
              g.model_qty = f.model_qty;
              return g;
            });
          this.orderGraviestotalRows = this.form.gravies.length;
          this.form.packagings = res.data.data
            .filter((f) => f.packaging != null)
            .map((f) => {
              let g = f.packaging;
              g.batch_code = f.batch_code;
              g.qty_to_ship = f.qty_to_ship;
              g.reason = f.reason;
              g.model_qty = f.model_qty;
              return g;
            });
          this.orderPackagingstotalRows = this.form.packagings.length;
        }
      } catch (e) {
        console.log(e);
      }
    },
    addGravy(v) {
      // if(this.restaurant){
      v.qty_to_ship = 1;
      // }else{
      //   v.qty_to_ship = v.Projected_Gravy_Utilization ?
      //       (v.gravy_units == 'pcs' ?
      //               (parseFloat((parseFloat(v.Projected_Gravy_Utilization).toFixed(0) ?? 0) / v.gravy_uom).toFixed(0) > 0 ?
      //                       parseFloat((parseFloat(v.Projected_Gravy_Utilization).toFixed(0) ?? 0) / v.gravy_uom).toFixed(0) :
      //                       1
      //               ) :
      //               ((parseFloat(v.Projected_Gravy_Utilization).toFixed(0) ?? 0) > 0 ? (parseFloat(v.Projected_Gravy_Utilization).toFixed(0) ?? 0) : 1)
      //       ) : 1;
      // }
      this.form.gravies.push(v);
    },
    addPackaging(v) {
      // if(this.restaurant){
      v.qty_to_ship = 1;
      // }else {
      //   v.qty_to_ship = parseFloat((parseFloat(v.Projected_Gravy_Utilization).toFixed(0) ?? 0)).toFixed(0);
      // }
      this.form.packagings.push(v);
    },
    setQty(e, v) {
      let index = this.form.gravies.findIndex((f) => f.id == v.id);
      if (isNaN(this.form.gravies[index].qty_to_ship)) {
        this.form.gravies[index].qty_to_ship = 0;
      }
      this.form.gravies[index].qty_to_ship = e;
    },
    addQty(v) {
      let index = this.form.gravies.findIndex(
        (f) => f.batch_code == v.batch_code && f.id == v.id
      );
      if (isNaN(this.form.gravies[index].qty_to_ship)) {
        this.form.gravies[index].qty_to_ship = 0;
      }
      this.form.gravies[index].qty_to_ship =
        parseInt(this.form.gravies[index].qty_to_ship) + 1;
      this.key += 1;
    },
    minusQty(v) {
      let index = this.form.gravies.findIndex(
        (f) => f.batch_code == v.batch_code && f.id == v.id
      );
      if (isNaN(this.form.gravies[index].qty_to_ship)) {
        this.form.gravies[index].qty_to_ship = 0;
      }
      if (
        this.order_type == "accepted" &&
        this.selectedOrder.created_by == "Dil Foods Model"
      ) {
        if (parseInt(this.form.gravies[index].qty_to_ship) <= 1) {
          this.form.gravies[index].qty_to_ship = 0;
          return;
        }
      } else {
        if (parseInt(this.form.gravies[index].qty_to_ship) - 1 < 1) {
          this.form.gravies.splice(index, 1);
          this.orderGraviestotalRows = this.form.gravies.length;
          return;
        }
      }
      this.form.gravies[index].qty_to_ship =
        parseInt(this.form.gravies[index].qty_to_ship) - 1;
      this.key += 1;
    },
    setPQty(e, v) {
      let index = this.form.packagings.findIndex((f) => f.id == v.id);
      if (isNaN(this.form.packagings[index].qty_to_ship)) {
        this.form.packagings[index].qty_to_ship = 0;
      }
      this.form.packagings[index].qty_to_ship = e;
    },
    addPQty(v) {
      let index = this.form.packagings.findIndex(
        (f) => f.batch_code == v.batch_code && f.id == v.id
      );
      if (v.packaging_batches) {
        index = this.form.packagings.findIndex(
          (f) =>
            f.packaging_batches[0].batch_code ==
              v.packaging_batches[0].batch_code && f.id == v.id
        );
      }
      if (isNaN(this.form.packagings[index].qty_to_ship)) {
        this.form.packagings[index].qty_to_ship = 0;
      }
      this.form.packagings[index].qty_to_ship =
        parseInt(this.form.packagings[index].qty_to_ship) + 1;
      this.key += 1;
    },
    minusPQty(v) {
      let index = this.form.packagings.findIndex(
        (f) => f.batch_code == v.batch_code && f.id == v.id
      );
      if (isNaN(this.form.packagings[index].qty_to_ship)) {
        this.form.packagings[index].qty_to_ship = 0;
      }
      if (
        this.order_type == "accepted" &&
        this.selectedOrder.created_by == "Dil Foods Model"
      ) {
        if (parseInt(this.form.packagings[index].qty_to_ship) <= 1) {
          this.form.packagings[index].qty_to_ship = 0;
          return;
        }
      } else {
        if (parseInt(this.form.packagings[index].qty_to_ship) - 1 < 1) {
          this.form.packagings.splice(index, 1);
          this.orderPackagingstotalRows = this.form.packagings.length;
          return;
        }
      }
      this.form.packagings[index].qty_to_ship =
        parseInt(this.form.packagings[index].qty_to_ship) - 1;
      this.key += 1;
    },
    validateData() {
      if (this.form.expected_delivery_date == null) {
        Swal.fire("Please Fill Expected Delivery Date", "", "error");
        return false;
      }
      return true;
    },
    addBatches(v, type) {
      this.selectedData.r = v;
      this.selectedData.type = type;
      this.selectedData.form = this.form;
      this.key += 1;
      this.$bvModal.show("add-batches");
    },
    selectedBatches(v) {
      if (this.selectedData.type == "gravies") {
        let index = this.form.gravies.findIndex(
          (f) => f.id == this.selectedData.r.id
        );
        this.form.gravies[index].batch_id = v.map((d) => d.b_code);
        this.item_key += 1;
      }
    },
    async saveOrder() {
      try {
        if (!this.validateData()) {
          return;
        }
        let res = await axios.post(
          this.baseUrl + GravyPath.ORDERS.SAVE,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-add-order");
          this.$emit("update");
        } else {
          Swal.fire(res.data.message, "", "error");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async updateOrder() {
      try {
        if (!this.validateData()) {
          return;
        }
        let res = await axios.put(
          this.baseUrl + GravyPath.ORDERS.SAVE + "/" + this.form.id,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-add-order");
          this.$emit("update");
        } else {
          Swal.fire(res.data.message, "", "error");
        }
      } catch (e) {
        Swal.fire(e.message, "", "error");
        console.log(e);
      }
    },
    async getBarcodeGravies() {
      try {
        if (!(this.form.res_id ? this.form.res_id : this.restaurant?.id)) {
          Swal.fire("Please select the restaurent first", "", "error");
          return;
        }
        let res = await axios.get(this.baseUrl + GravyPath.GRAVY_ORDER_LEVEL, {
          params: {
            brand_id: this.selected_brand,
            res_id: this.form.res_id ? this.form.res_id : this.restaurant?.id,
            daterange: this.projection_date,
            barcode: this.barcode,
          },
        });
        if (res.data.status) {
          let d = res.data.data.data[0];
          let check = this.form.gravies.findIndex(
            (f) => f.id == d.id && f.batch_code == d.gravy_batch[0].batch_code
          );
          if (check !== -1) {
            this.form.gravies[check].qty_to_ship += 1;
          } else {
            d.qty_to_ship = 1;
            d.batch_code = d.gravy_batch[0].batch_code;
            delete d.gravy_batch;
            // d.batch_id.push(this.barcode);
            this.form.gravies.unshift(d);
            this.orderGraviestotalRows = this.form.gravies.length;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getBarcodePackagings() {
      try {
        if (!(this.form.res_id ? this.form.res_id : this.restaurant?.id)) {
          Swal.fire("Please select the restaurent first", "", "error");
          return;
        }
        let res = await axios.get(
          this.baseUrl + PackagingPath.PACKAGING_ORDER_LEVEL,
          {
            params: {
              brand_id: this.selected_brand,
              res_id: this.form.res_id ? this.form.res_id : this.restaurant?.id,
              daterange: this.projection_date,
              barcode: this.barcode,
            },
          }
        );
        if (res.data.status) {
          let d = res.data.data.data[0];
          let check = this.form.packagings.findIndex(
            (f) => f.id == d.id && f.batch_code
          );
          if (check !== -1) {
            this.form.packagings[check].qty_to_ship += 1;
          } else {
            d.qty_to_ship = 1;
            d.batch_code = d.packaging_batches[0].batch_code;
            delete d.packaging_batch;
            this.form.packagings.unshift(d);
            this.orderPackagingstotalRows = this.form.packagings.length;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getGravies() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.GRAVY_ORDER_LEVEL, {
          params: {
            page: this.currentGraviesPage,
            search: this.gravies_search,
            brand_id: this.selected_brand,
            res_id: this.form.res_id ? this.form.res_id : this.restaurant?.id,
            daterange: this.projection_date,
          },
        });
        if (res.data.status) {
          this.gravies = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPackagings() {
      try {
        let res = await axios.get(
          this.baseUrl + PackagingPath.PACKAGING_ORDER_LEVEL,
          {
            params: {
              page: this.currentPackagingPage,
              search: this.packaging_search,
              brand_id: this.selected_brand,
              res_id: this.form.res_id ? this.form.res_id : this.restaurant?.id,
              daterange: this.projection_date,
            },
          }
        );
        if (res.data.status) {
          this.packagings = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    selectRestaurant(v) {
      this.form.res_id = v;
      this.currentPage = 1;
      this.getBrands();
      this.getGravies();
    },
    toggleSelected() {},
    getBatches(v) {
      let data = [];
      let d = this.form.gravies.filter((f) => f.id == v.id);
      if (d.length > 0) {
        if (d[0].batch_id && d[0].batch_id.length > 0) {
          data = d[0].batch_id;
        }
      }
      return data;
    },
    onOrderGraviesFiltered(filteredItems) {
      this.orderGraviestotalRows = filteredItems.length;
      this.orderGraviesPage = 1;
    },
    onOrderPackagingsFiltered(filteredItems) {
      this.orderPackagingstotalRows = filteredItems.length;
      this.orderPackagingsPage = 1;
    },
  },
});
</script>

<template>
  <div id="add-order">
    <b-modal
      id="add-batches"
      size="lg"
      hide-footer
      :title="Object.keys(selectedData).length > 0 ? selectedData.name : ''"
    >
      <batches
        :key="key"
        :r="selectedData.r"
        :type="selectedData.type"
        :form="form"
        @selectedBatches="selectedBatches"
      >
      </batches>
    </b-modal>
    <b-row>
      <b-col sm="6">
        <label>Restaurant Partner</label>
        <p v-if="restaurant != null">{{ restaurant.name }}</p>
        <select-with-search
          v-else
          :search_api="RestaurantsPath.GET_RESTAURANTS"
          selected_by="id"
          track_by="id"
          display="name"
          @selectedOption="selectRestaurant"
        ></select-with-search>
      </b-col>
      <b-col sm="6">
        <label>Special Instruction</label>
        <b-form-textarea v-model="form.special_instruction"></b-form-textarea>
      </b-col>
      <!-- <b-col sm="6" v-if="restaurant == null">
        <label>Projection Date</label>
        <date-picker range v-model="projection_date" show-week-number :lang="lang"></date-picker>
      </b-col> -->
    </b-row>
    <b-row
      v-if="
        $store.state.authfack.user.roles.filter(
          (f) => f.name == 'RestaurantPartner'
        ).length == 0
      "
    >
      <b-col sm="6" lg="4">
        <b-form-group label="Order Type" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            id="radio-slots-order_type"
            v-model="form.order_type"
            :options="order_type_options"
            :aria-describedby="ariaDescribedby"
            name="radio-options-slots-order_type"
          >
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="6" lg="4">
        <b-form-group label="Payment Mode" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            id="radio-slots-payment"
            v-model="form.payment_mode"
            :options="payment_mode_options"
            :aria-describedby="ariaDescribedby"
            name="radio-options-slots-payment"
          >
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-tabs
        v-if="
          selectedOrder.order_status == 'pending' ||
          selectedOrder.order_status == 'accepted' ||
          selectedOrder.order_status == 'stock_out' ||
          Object.keys(selectedOrder).length == 0
        "
        card
      >
        <b-tab
          title="BarCode Scanning"
          v-if="
            this.$store.state.authfack.user.roles.filter(
              (f) => f.name == 'RestaurantPartner'
            ).length == 0
          "
          class="barcode"
        >
          <div class="row align-items-center pb-4">
            <div class="col-8">
              <input
                type="text"
                v-model="barcode"
                @keyup.enter="processBarcode"
                ref="barcodeInput"
                placeholder="Scan a barcode"
                class="form-control"
              />
            </div>
            <div class="col-2">
              <b-button
                v-if="showBarcodeReader == false"
                @click="() => (showBarcodeReader = true)"
                variant="success"
                class="ml-2"
              >
                <i class="fa fa-camera"></i>
              </b-button>
              <b-button
                v-else
                @click="() => (showBarcodeReader = false)"
                variant="danger"
                class="ml-2"
              >
                <i class="fa fa-times"></i>
              </b-button>
            </div>
          </div>
          <StreamBarcodeReader
            v-if="showBarcodeReader == true"
            @decode="processBarcodeByCam"
            @error="(e) => console.log(e)"
          ></StreamBarcodeReader>
          <b-tabs pills>
            <b-tab title="Gravies">
              <div class="table-responsive mb-0">
                <div class="pb-2 float-md-right w-sm-100 w-md-25">
                  <b-row class="mb-3">
                    <b-col sm="12" class="mt-4">
                      <b-form-group
                        label-for="filter-input"
                        label-cols-sm="0"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                      >
                        <b-input-group size="sm">
                          <b-input-group-prepend is-text>
                            <i class="fa fa-search"></i>
                          </b-input-group-prepend>
                          <b-form-input
                            id="filter-input"
                            v-model="orderGraviesfilter"
                            type="search"
                            placeholder="Type to Search"
                          ></b-form-input>

                          <b-input-group-append>
                            <b-button
                              :disabled="!orderGraviesfilter"
                              @click="orderGraviesfilter = ''"
                              >Clear</b-button
                            >
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <b-table
                  :key="item_key"
                  :items="form.gravies"
                  :fields="
                    order_type == 'accepted' &&
                    selectedOrder.created_by == 'Dil Foods Model'
                      ? fields
                      : pending_fields
                  "
                  responsive="sm"
                  :filter="orderGraviesfilter"
                  :perPage="10"
                  :currentPage="orderGraviesPage"
                  @filtered="onOrderGraviesFiltered"
                >
                  <template v-slot:cell(HEAD_actions)="row">
                    {{ row }} &nbsp;
                    <input
                      type="checkbox"
                      @click.stop="toggleSelected"
                      v-model="allSelected"
                    />
                  </template>
                  <template v-slot:cell(batch_code)="row">
                    {{ row.item.batch_code }}
                  </template>
                  <template v-slot:cell(name)="row">
                    <p>
                      {{
                        row.item.name +
                        "(" +
                        row.item.uom +
                        "" +
                        row.item.units +
                        ")"
                      }}
                    </p>
                  </template>
                  <template v-slot:cell(reason)="row">
                    <b-form-select
                      v-model="row.item.reason"
                      :options="reason_options"
                    ></b-form-select>
                  </template>
                  <template v-slot:cell(price)="row">
                    Rs. {{ row.item.selling_price }}
                  </template>
                  <!-- <template v-slot:cell(projection)="row">-->
                  <!--                {{ row.item.gravy_units == 'pcs' ? parseFloat((parseFloat(row.item.Projected_Gravy_Utilization).toFixed(0) ?? 0) / row.item.gravy_uom).toFixed(0) : (parseFloat(row.item.Projected_Gravy_Utilization).toFixed(0) ?? 0) }} &nbsp;<i class="fa fa-times"></i>&nbsp; {{row.item.gravy_uom}}{{row.item.units}}-->
                  <!--              </template> -->
                  <template v-slot:cell(images)="row">
                    <b-img
                      v-for="(im, i) in row.item.images"
                      :src="cdn + '/' + im.img_url"
                      :key="i"
                      size="20"
                    ></b-img>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div
                      class="row"
                      v-if="
                        form.gravies.filter(
                          (f) =>
                            f.id == row.item.id &&
                            f.batch_code == row.item.batch_code
                        ).length > 0
                      "
                    >
                      <b-input-group style="width: 130px">
                        <b-input-group-prepend>
                          <b-button
                            @click="minusQty(row.item)"
                            size="sm"
                            variant="primary"
                            :disabled="
                              order_type == 'accepted' &&
                              selectedOrder.created_by == 'Dil Foods Model' &&
                              !row.item.reason
                            "
                            ><i class="fa fa-minus"></i
                          ></b-button>
                        </b-input-group-prepend>
                        <b-form-input
                          type="number"
                          :key="row.item.id + key"
                          :value="
                            form.gravies.filter(
                              (f) =>
                                f.id == row.item.id &&
                                f.batch_code == row.item.batch_code
                            )[0].qty_to_ship
                          "
                          min="0"
                          v-if="form.gravies.filter((f) => f.id == row.item.id)"
                          @input="setQty($event, row.item)"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            @click="addQty(row.item)"
                            size="sm"
                            variant="primary"
                            :disabled="
                              order_type == 'accepted' &&
                              selectedOrder.created_by == 'Dil Foods Model' &&
                              !row.item.reason
                            "
                            ><i class="fa fa-plus"></i
                          ></b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <b-button
                      v-else
                      @click="addGravy(row.item)"
                      variant="primary"
                    >
                      Add
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        :key="form.gravies.key"
                        v-model="orderGraviesPage"
                        :total-rows="orderGraviestotalRows"
                        :per-page="10"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Packagings">
              <div class="table-responsive mb-0">
                <div class="pb-2 float-md-right w-sm-100 w-md-25">
                  <b-row>
                    <b-col sm="12" class="mt-4">
                      <b-form-group
                        label-for="filter-input"
                        label-cols-sm="0"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                      >
                        <b-input-group size="sm">
                          <b-input-group-prepend is-text>
                            <i class="fa fa-search"></i>
                          </b-input-group-prepend>
                          <b-form-input
                            id="filter-input"
                            v-model="orderPackagingsfilter"
                            type="search"
                            placeholder="Type to Search"
                          ></b-form-input>

                          <b-input-group-append>
                            <b-button
                              :disabled="!orderPackagingsfilter"
                              @click="orderPackagingsfilter = ''"
                              >Clear</b-button
                            >
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <b-table
                  :key="form.packagings"
                  :items="form.packagings"
                  :fields="
                    order_type == 'accepted' &&
                    selectedOrder.created_by == 'Dil Foods Model'
                      ? fields
                      : pending_fields
                  "
                  responsive="sm"
                  :filter="orderPackagingsfilter"
                  :perPage="10"
                  :currentPage="orderPackagingsPage"
                  @filtered="onOrderPackagingsFiltered"
                >
                  <template v-slot:cell(price)="row">
                    {{ row.item.selling_price }}
                  </template>
                  <template v-slot:cell(batch_code)="row">
                    {{ row.item.batch_code }}
                  </template>
                  <template v-slot:cell(reason)="row">
                    <b-form-select
                      v-model="row.item.reason"
                      :options="reason_options"
                    ></b-form-select>
                  </template>
                  <template v-slot:cell(images)="row">
                    <b-img
                      v-for="(im, i) in row.item.images"
                      :src="cdn + '/' + im.img_url"
                      :key="i"
                      size="20"
                    ></b-img>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div
                      v-if="
                        form.packagings.filter((f) => f.id == row.item.id)
                          .length > 0
                      "
                    >
                      <b-input-group style="width: 130px">
                        <b-input-group-prepend>
                          <b-button
                            @click="minusPQty(row.item)"
                            size="sm"
                            variant="primary"
                            :disabled="
                              order_type == 'accepted' &&
                              selectedOrder.created_by == 'Dil Foods Model' &&
                              !row.item.reason
                            "
                            ><i class="fa fa-minus"></i
                          ></b-button>
                        </b-input-group-prepend>
                        <b-form-input
                          type="number"
                          :key="row.item.id + key"
                          :value="row.item.qty_to_ship"
                          min="0"
                          @input="setPQty($event, row.item)"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            @click="addPQty(row.item)"
                            size="sm"
                            variant="primary"
                            :disabled="
                              order_type == 'accepted' &&
                              selectedOrder.created_by == 'Dil Foods Model' &&
                              !row.item.reason
                            "
                            ><i class="fa fa-plus"></i
                          ></b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <b-button
                      v-else
                      @click="addPackaging(row.item)"
                      variant="primary"
                    >
                      Add
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        :key="form.packagings.key"
                        v-model="orderPackagingsPage"
                        :total-rows="orderPackagingstotalRows"
                        :per-page="10"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab title="Gravies" class="p-2 p-md-3">
          <b-tabs pills style="width: 100%; overflow: hidden">
            <b-tab
              v-for="(b, bi) in brands"
              :title="b.name"
              :key="bi"
              @click="() => (selected_brand = b.id)"
            ></b-tab>
          </b-tabs>
          <div class="pb-2 float-md-right w-sm-100 w-md-25">
            <b-row class="mb-3">
              <b-col sm="12" class="mt-4">
                <b-input-group size="sm">
                  <b-input-group-prepend is-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-prepend>
                  <b-input
                    size="sm"
                    placeholder="Search"
                    v-model="gravies_search"
                  ></b-input>
                </b-input-group>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive">
            <b-table
              :key="item_key"
              :items="gravies.data"
              :fields="restaurant ? fields_res : fields"
              responsive="sm"
              :filter="filter"
              :current-page="currentPage"
            >
              <template v-slot:cell(HEAD_actions)="row">
                {{ row }} &nbsp;
                <input
                  type="checkbox"
                  @click.stop="toggleSelected"
                  v-model="allSelected"
                />
              </template>
              <template v-slot:cell(name)="row">
                <p>
                  {{
                    row.item.name +
                    "(" +
                    row.item.uom +
                    "" +
                    row.item.units +
                    ")"
                  }}
                </p>
                <p>
                  <b-badge
                    v-for="(b, bi) in getBatches(row.item)"
                    variant="success"
                    :key="bi"
                    >{{ b }}</b-badge
                  >
                </p>
              </template>
              <template v-slot:cell(price)="row">
                Rs. {{ row.item.selling_price }}
              </template>
              <template v-slot:cell(images)="row">
                <b-img
                  v-for="(im, i) in row.item.images"
                  :src="cdn + '/' + im.img_url"
                  :key="i"
                  size="20"
                ></b-img>
              </template>
              <template v-slot:cell(actions)="row">
                <div
                  class="row"
                  v-if="
                    form.gravies.filter((f) => f.id == row.item.id).length > 0
                  "
                >
                  <div>
                    <b-input-group style="width: 130px">
                      <b-input-group-prepend>
                        <b-button @click="minusQty(row.item)" size="sm"
                          ><i class="fa fa-minus"></i
                        ></b-button>
                      </b-input-group-prepend>
                      <b-form-input
                        type="number"
                        :key="row.item.id + key"
                        :value="
                          form.gravies.filter((f) => f.id == row.item.id)[0]
                            .qty_to_ship
                        "
                        min="0"
                        v-if="form.gravies.filter((f) => f.id == row.item.id)"
                        @input="setQty($event, row.item)"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button @click="addQty(row.item)" size="sm"
                          ><i class="fa fa-plus"></i
                        ></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </div>
                <b-button v-else @click="addGravy(row.item)" variant="primary">
                  Add
                </b-button>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    :key="gravies.key"
                    v-model="currentGraviesPage"
                    :total-rows="gravies.total"
                    :per-page="gravies.per_page"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Packaging" class="p-2 p-md-3">
          <b-tabs pills>
            <b-tab
              v-for="(b, bi) in brands"
              :title="b.name"
              :key="bi"
              @click="() => (selected_brand = b.id)"
            ></b-tab>
          </b-tabs>
          <div class="table-responsive mb-0">
            <div class="pb-2 float-md-right w-sm-100 w-md-25">
              <b-row>
                <b-col sm="12">
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      <i class="fa fa-search"></i>
                    </b-input-group-prepend>
                    <b-input
                      size="sm"
                      placeholder="Search"
                      v-model="packaging_search"
                    ></b-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>
            <b-table
              :key="packagings.key"
              :items="packagings.data"
              :fields="restaurant ? fields_res : fields"
              responsive="sm"
              :filter="filter"
            >
              <template v-slot:cell(price)="row">
                {{ row.item.selling_price }}
              </template>
              <template v-slot:cell(images)="row">
                <b-img
                  v-for="(im, i) in row.item.images"
                  :src="cdn + '/' + im.img_url"
                  :key="i"
                  size="20"
                ></b-img>
              </template>
              <template v-slot:cell(actions)="row">
                <div
                  v-if="
                    form.packagings.filter((f) => f.id == row.item.id).length >
                    0
                  "
                >
                  <b-input-group style="width: 130px">
                    <b-input-group-prepend>
                      <b-button @click="minusPQty(row.item)" size="sm"
                        ><i class="fa fa-minus"></i
                      ></b-button>
                    </b-input-group-prepend>
                    <b-form-input
                      type="number"
                      :key="row.item.id + key"
                      :value="
                        form.packagings.filter((f) => f.id == row.item.id)[0]
                          .qty_to_ship
                      "
                      min="0"
                      v-if="form.packagings.filter((f) => f.id == row.item.id)"
                      @input="setPQty($event, row.item)"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button @click="addPQty(row.item)" size="sm"
                        ><i class="fa fa-plus"></i
                      ></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <b-button
                  v-else
                  @click="addPackaging(row.item)"
                  variant="primary"
                >
                  Add
                </b-button>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    :key="packagings.key"
                    v-model="currentPackagingPage"
                    :total-rows="packagings.total"
                    :per-page="packagings.per_page"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <b-card-footer>
        <b-row class="align-items-end">
          <b-col
            cols="9"
            md="6"
            v-if="
              selectedOrder.order_status == 'pending' ||
              selectedOrder.order_status == 'accepted' ||
              Object.keys(selectedOrder).length == 0
            "
          >
            <label>Expected Delivery</label>
            <b-form-datepicker
              v-model="form.expected_delivery_date"
            ></b-form-datepicker>
          </b-col>
          <b-col cols="2" md="6">
            <b-button
              v-if="Object.keys(selectedOrder).length == 0"
              variant="success"
              @click="saveOrder"
              >Save</b-button
            >
            <b-button v-else variant="success" @click="updateOrder"
              >Save</b-button
            >
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<style>
@media (max-width: 768px) {
}

@media (max-width: 767.98px) {
  #add-order .dataTables_paginate ul {
    display: flex;
  }
}

.tab-container {
  max-width: 100%;
  overflow-x: auto;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.nav-pills .nav-link {
  color: #fff;
  background-color: #959595;
  margin-left: 10px;
  margin-bottom: 10px;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #fff;
  background-color: #0e3bee;
  border-color: #8c8c8d #949494 #fff;
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: #cecece;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  margin-left: 10px;
}

.custom-card {
  max-width: 18rem;
  margin-bottom: 1rem;
  /* Adjust the margin-bottom as needed */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}
div.scanner-container > div {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 100 !important;
  background-color: black !important;
  display: flex !important;
  flex-flow: column nowrap !important;
  justify-content: center !important;
}
</style>
